import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import "../site.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function PayPilot() {
  const [state, setState] = useState("idle");
  const startCheckout = async () => {
    setState("loading");
    try {
      const res = await fetch(`${API}/payments/checkout`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ lookup_key: "pilot_3000", quantity: 1, origin_url: window.location.origin })
      });
      if (!res.ok) throw new Error("checkout failed");
      const data = await res.json();
      window.location.href = data.checkout_url;
    } catch (e) {
      setState("error");
    }
  };
  return (
    <div className="pay-page">
      <div className="container">
        <div className="pay-card" data-testid="pay-pilot-page">
          <h1>Interactive pilot payment</h1>
          <span className="pay-status" data-testid="pay-pilot-status">$3,000 · one-time · secure checkout</span>
          <p>This page is for clients with an approved Digital Static pilot agreement. Payment covers one scoped interactive pilot as defined in your written proposal. If you have not agreed a pilot scope yet, please start with a no-charge discovery conversation instead.</p>
          <button className="btn btn-primary" data-testid="pilot-pay-button" onClick={startCheckout} disabled={state === "loading"}>
            {state === "loading" ? "Preparing secure checkout…" : "Continue to secure payment ↗"}
          </button>
          {state === "error" && <p className="pay-status error" data-testid="pay-error">Checkout is unavailable right now — please email ronald.scott.digitalstaticllc@gmail.com</p>}
          <p style={{fontSize:'12px'}}>Questions? Email <a className="inline" href="mailto:ronald.scott.digitalstaticllc@gmail.com">ronald.scott.digitalstaticllc@gmail.com</a> or call (301) 437-2485.</p>
          <Link className="btn btn-outline" data-testid="back-home" to="/">Back to Digital Static <span aria-hidden="true">→</span></Link>
        </div>
      </div>
    </div>
  );
}

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id") || "";
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;
    const poll = async () => {
      try {
        const res = await fetch(`${API}/payments/status/${sessionId}`);
        if (!res.ok) throw new Error("not found");
        const data = await res.json();
        if (cancelled) return;
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        attempts.current += 1;
        if (attempts.current < 10) setTimeout(poll, 2000);
        else setStatus("pending");
      } catch (e) {
        if (!cancelled) setStatus("error");
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="pay-page">
      <div className="container">
        <div className="pay-card" data-testid="payment-success-page">
          <h1>Thank you — your pilot payment is in.</h1>
          {status === "checking" && <span className="pay-status" data-testid="payment-status">Confirming your payment…</span>}
          {status === "paid" && <span className="pay-status" data-testid="payment-status">Payment confirmed</span>}
          {status === "pending" && <span className="pay-status" data-testid="payment-status">Payment processing</span>}
          {status === "error" && <span className="pay-status error" data-testid="payment-status">Could not confirm payment</span>}
          <p>
            {status === "paid"
              ? "Your interactive pilot payment was received. The Digital Static team will contact you to schedule your scoping session and agree the training scenario."
              : "We are confirming your payment with our payment provider. If you were charged, the Digital Static team will contact you shortly to schedule your pilot."}
          </p>
          <p style={{fontSize:'12px'}}>Questions? Email <a href="mailto:ronald.scott.digitalstaticllc@gmail.com" style={{color:'#1b5ed8',textDecoration:'underline'}}>ronald.scott.digitalstaticllc@gmail.com</a> or call (301) 437-2485.</p>
          <Link className="btn btn-primary" data-testid="back-home" to="/">Back to Digital Static <span aria-hidden="true">→</span></Link>
        </div>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="pay-page">
      <div className="container">
        <div className="pay-card" data-testid="payment-cancel-page">
          <h1>No charge was made.</h1>
          <span className="pay-status error" data-testid="payment-status">Checkout cancelled</span>
          <p>You left the secure checkout before paying — nothing was charged. Whenever you're ready, you can restart the pilot payment or simply start with a no-charge discovery conversation.</p>
          <Link className="btn btn-primary" data-testid="back-home" to="/">Back to Digital Static <span aria-hidden="true">→</span></Link>
        </div>
      </div>
    </div>
  );
}
